module.exports = __webpack_public_path__ + "media/images/pic/teachers/katarzyna-lesniewska-01cf7846cd7e496ae6ad988e8e140a4f.png";